// extracted by mini-css-extract-plugin
export default {"logo":"Hire_logo__C5ZEU"};